export class CodeValueMessageArg {

    constructor(
      public code?: string,
      public value?: string
    ) {

    }
}
